import React, { useState, useMemo, useEffect } from "react";
import {
  Stepper,
  Step,
  StepLabel,
  StepConnector,
  Box,
  Button,
} from "@mui/material";
import { stepConnectorClasses } from "@mui/material/StepConnector";
import { styled } from "@mui/material/styles";
import { useLocation } from "react-router-dom";
import { clientRoutes } from "src/utils/routes";

const CompletedCheckIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 10C20 11.9778 19.4135 13.9112 18.3147 15.5557C17.2159 17.2002 15.6541 18.4819 13.8268 19.2388C11.9996 19.9957 9.98891 20.1937 8.0491 19.8079C6.10929 19.422 4.32746 18.4696 2.92894 17.0711C1.53041 15.6725 0.578004 13.8907 0.192152 11.9509C-0.193701 10.0111 0.00433284 8.00043 0.761209 6.17317C1.51809 4.3459 2.79981 2.78412 4.4443 1.6853C6.08879 0.58649 8.02219 0 10 0C12.6522 0 15.1957 1.05357 17.0711 2.92893C18.9464 4.8043 20 7.34784 20 10ZM15.037 6.213C14.9477 6.12406 14.8414 6.05402 14.7245 6.00707C14.6075 5.96012 14.4823 5.93722 14.3563 5.93974C14.2303 5.94226 14.1061 5.97015 13.9911 6.02173C13.8761 6.07332 13.7727 6.14756 13.687 6.24L9.346 11.771L6.73 9.154C6.55162 8.99199 6.31773 8.90485 6.07683 8.91064C5.83593 8.91643 5.6065 9.01471 5.43611 9.1851C5.26572 9.3555 5.16744 9.58493 5.16165 9.82583C5.15585 10.0667 5.243 10.3006 5.405 10.479L8.712 13.787C8.80115 13.8759 8.90728 13.946 9.02407 13.993C9.14086 14.04 9.26593 14.0631 9.39181 14.0607C9.51769 14.0584 9.64182 14.0307 9.75679 13.9794C9.87176 13.9281 9.97522 13.8542 10.061 13.762L15.051 7.524C15.2212 7.3471 15.3153 7.11053 15.3131 6.86505C15.3108 6.61957 15.2124 6.38476 15.039 6.211L15.037 6.213Z"
        fill="#4AAC1D"
      />
    </svg>
  );
};
const DefaultCheckIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.75 18.7508C13.0996 18.7796 15.3645 17.8739 17.0464 16.2331C18.7284 14.5922 19.6897 12.3504 19.719 10.0008C19.6897 7.65114 18.7284 5.40936 17.0464 3.76846C15.3645 2.12756 13.0996 1.22194 10.75 1.25076C8.40038 1.22194 6.13552 2.12756 4.45355 3.76846C2.77159 5.40936 1.81026 7.65114 1.781 10.0008C1.81026 12.3504 2.77159 14.5922 4.45355 16.2331C6.13552 17.8739 8.40038 18.7796 10.75 18.7508ZM10.75 20.0008C13.4352 20.0336 16.0235 18.9985 17.9457 17.1232C19.8679 15.2479 20.9665 12.686 21 10.0008C20.9665 7.31554 19.8679 4.75357 17.9457 2.87828C16.0235 1.00298 13.4352 -0.0320675 10.75 0.00075758C8.06478 -0.0320675 5.47646 1.00298 3.55429 2.87828C1.63211 4.75357 0.533477 7.31554 0.5 10.0008C0.533477 12.686 1.63211 15.2479 3.55429 17.1232C5.47646 18.9985 8.06478 20.0336 10.75 20.0008Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.798 6.02214C14.9935 5.8349 15.253 5.72921 15.5237 5.72661C15.7944 5.72401 16.0559 5.82469 16.255 6.00814C16.3511 6.09641 16.428 6.20344 16.4811 6.32264C16.5342 6.44183 16.5623 6.57064 16.5636 6.70111C16.5649 6.83158 16.5394 6.96092 16.4887 7.08116C16.4381 7.2014 16.3633 7.30996 16.269 7.40014L10.785 13.9511C10.5898 14.1479 10.3254 14.2608 10.0483 14.2656C9.77112 14.2705 9.503 14.167 9.301 13.9771L5.668 10.5031C5.53257 10.3861 5.43268 10.2335 5.37965 10.0626C5.32662 9.89163 5.32258 9.70925 5.368 9.53614C5.41674 9.36103 5.51189 9.20234 5.64337 9.07684C5.77486 8.95133 5.93781 8.86368 6.115 8.82314C6.29425 8.77913 6.48188 8.78263 6.65936 8.83332C6.83684 8.884 6.99802 8.9801 7.127 9.11214L10.004 11.8591L14.771 6.05114C14.7794 6.04092 14.7884 6.03123 14.798 6.02214Z"
        fill="white"
      />
    </svg>
  );
};
const CurrentCheckIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.25 18.7508C12.5996 18.7796 14.8645 17.8739 16.5464 16.2331C18.2284 14.5922 19.1897 12.3504 19.219 10.0008C19.1897 7.65114 18.2284 5.40936 16.5464 3.76846C14.8645 2.12756 12.5996 1.22194 10.25 1.25076C7.90038 1.22194 5.63552 2.12756 3.95355 3.76846C2.27159 5.40936 1.31026 7.65114 1.281 10.0008C1.31026 12.3504 2.27159 14.5922 3.95355 16.2331C5.63552 17.8739 7.90038 18.7796 10.25 18.7508ZM10.25 20.0008C12.9352 20.0336 15.5235 18.9985 17.4457 17.1232C19.3679 15.2479 20.4665 12.686 20.5 10.0008C20.4665 7.31554 19.3679 4.75357 17.4457 2.87828C15.5235 1.00298 12.9352 -0.0320675 10.25 0.00075758C7.56478 -0.0320675 4.97646 1.00298 3.05429 2.87828C1.13211 4.75357 0.0334765 7.31554 0 10.0008C0.0334765 12.686 1.13211 15.2479 3.05429 17.1232C4.97646 18.9985 7.56478 20.0336 10.25 20.0008Z"
        fill="url(#paint0_linear_1805_16102)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.298 6.02214C14.4935 5.8349 14.753 5.72921 15.0237 5.72661C15.2944 5.72401 15.5559 5.82469 15.755 6.00814C15.8511 6.09641 15.928 6.20344 15.9811 6.32264C16.0342 6.44183 16.0623 6.57064 16.0636 6.70111C16.0649 6.83158 16.0394 6.96092 15.9887 7.08116C15.9381 7.2014 15.8633 7.30996 15.769 7.40014L10.285 13.9511C10.0898 14.1479 9.82544 14.2608 9.54828 14.2656C9.27112 14.2705 9.003 14.167 8.801 13.9771L5.168 10.5031C5.03257 10.3861 4.93268 10.2335 4.87965 10.0626C4.82662 9.89163 4.82258 9.70925 4.868 9.53614C4.91674 9.36103 5.01189 9.20234 5.14337 9.07684C5.27486 8.95133 5.43781 8.86368 5.615 8.82314C5.79425 8.77913 5.98188 8.78263 6.15936 8.83332C6.33684 8.884 6.49802 8.9801 6.627 9.11214L9.504 11.8591L14.271 6.05114C14.2794 6.04092 14.2884 6.03123 14.298 6.02214Z"
        fill="url(#paint1_linear_1805_16102)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1805_16102"
          x1="10.25"
          y1="0"
          x2="10.25"
          y2="20.0015"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00EEFD" />
          <stop offset="1" stopColor="#0055FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1805_16102"
          x1="10.4501"
          y1="5.72656"
          x2="10.4501"
          y2="14.2658"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00EEFD" />
          <stop offset="1" stopColor="#0055FF" />
        </linearGradient>
      </defs>
    </svg>
  );
};

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 10, // Aligns vertically with icon center
    left: "calc(-50% + 8px)", // Connects to left edge of icon
    right: "calc(50% + 10px)", // Connects to right edge of icon
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 2,
    border: 0,
    backgroundColor: "#e0e0e0",
    borderRadius: 0, // Remove rounded edges for sharp connection
  },
  [`&.${stepConnectorClasses.active} .${stepConnectorClasses.line}`]: {
    backgroundImage: "linear-gradient(to bottom, #00EEFD, #0055FF)",
  },
  [`&.${stepConnectorClasses.completed} .${stepConnectorClasses.line}`]: {
    backgroundColor: "#4caf50",
  },
}));

// Custom step icon component with better styling
const ColorlibStepIcon = (props: any) => {
  const { active, completed } = props;

  if (completed) {
    return <CompletedCheckIcon />;
  }
  if (active) {
    return <CurrentCheckIcon />;
  }
  return <DefaultCheckIcon />;
};

// Main progress steps component
const ProgressSteps = ({ steps, activeStep }: any) => {
  return (
    <Box sx={{ width: "100%" }}>
      <Stepper
        alternativeLabel
        activeStep={activeStep}
        connector={<ColorlibConnector />}
        sx={{
          "& .MuiStep-root": {
            padding: 0,
          },
        }}
      >
        {steps.map((step: any, index: any) => (
          <Step key={step.label} completed={step.completed}>
            <StepLabel
              StepIconComponent={ColorlibStepIcon}
              sx={{
                "& .MuiStepLabel-label": {
                  fontSize: "12px",
                  // fontWeight: step.active ? 600 : 400,
                  ...(step.active && {
                    background: "linear-gradient(to bottom, #00EEFD, #0055FF)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                  }),
                  ...(step.completed && {
                    color: "#4AAC1D !important",
                  }),
                  ...(!step.active &&
                    !step.completed && {
                      color: "#FFFFFF",
                    }),
                },
              }}
            >
              {step.label}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
};

const MultiStepRegistration = () => {
  const location = useLocation();

  // Step flows
  const registrationLabels = [
    "Sign up",
    "Email verification",
    "Sign in",
    "Mobile verification",
    "Login",
  ];

  // Step path mappings
  const registrationMap = {
    [clientRoutes.login]: 0,
    [clientRoutes.login]: 1,
    [clientRoutes.login]: 2,
    [clientRoutes.login]: 3,
    [clientRoutes.login]: 4,
  };

  // Determine flow type
  const currentFlow = useMemo(() => {
    if (location.pathname in registrationMap) return "registration";
    return "none";
  }, [location.pathname]);

  const { labels, map } = useMemo(() => {
    switch (currentFlow) {
      case "registration":
        return { labels: registrationLabels, map: registrationMap };
      default:
        return { labels: registrationLabels, map: registrationMap };
    }
  }, [currentFlow]);

  const [currentStep, setCurrentStep] = useState(4);

  //   // Update currentStep when path changes
  //   useEffect(() => {
  //     const step = map[location.pathname] ?? 0;
  //     setCurrentStep(step);
  //   }, [location.pathname, map]);

  const steps = labels.map((label, index) => ({
    label,
    active: index === currentStep,
    completed: index < currentStep,
  }));

  //   if (currentFlow === "none") return null; // optionally handle unknown flows

  return (
    <Box sx={{ width: "100%" }}>
      <ProgressSteps steps={steps} activeStep={currentStep} />
    </Box>
  );
};

export default MultiStepRegistration;
